<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div v-show="CheckRoute()" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet kt-portlet--mobile">
          <div class="kt-portlet__head kt-portlet__head--lg">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="fa fa-money-check-alt"></i>
              </span>
              <h3 class="kt-portlet__head-title">
                {{ this.$route.meta.breadcrumb }}
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <!-- begin: Search Form -->
            <form class="kt-form" @submit="formSubmit" ref="searchForm">
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrAgentCodes'"
                    :name="'pmrAgentCodes'"
                    :select2-options="pmrAgentCodesOptions"
                    v-model="pmrAgentCodes"
                    ref="pmrAgentCodesSelect2"
                    multiple
                  ></select2> -->
                  <treeselect v-model="pmrAgentCodes" 
                  :multiple="true" 
                  :options="pmrAgentCodesOptions" 
                  :clear-on-select="true"  
                  v-on:select="AgentClearAfterselect"
                  v-on:deselect="AgentClearAfterselect"
                  
                  placeholder="กรุณาเลือก" />
                </div>
              </div> 
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่าย:</label> 
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrShopCodes'"
                    :name="'pmrShopCodes'"
                    :select2-options="pmrShopCodesOptions"
                    v-model="pmrShopCodes"
                    @selectChange="ShopClearAfterselect" 
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  <p
                    class="text-danger"
                    v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
                  >
                     
                  </p>
                </div>
              </div> 

               <!-------ตัวแทนย่อย---->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                   
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    @selectChange="SubAgentClearAfterselect" 
                    ref="pmrSubAgentCodesSelect2"
                    multiple
                  ></select2>
 
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6" v-show="this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentShopCodes'"
                    :name="'pmrSubAgentShopCodes'"
                    :select2-options="pmrSubAgentShopCodesOptions"
                    v-model="pmrSubAgentShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  <p
                    class="text-danger"
                    v-show="this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])"
                  >
                     
                  </p>
                </div>
              </div>
            <!-------สิ้นสุดตัวแทนย่อย-->

            <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>แบรนด์งาน PM:</label>
                  <!-- <label>Brand:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMBrand'"
                    :name="'rePMBrand'"
                    :select2-options="rePMBrandOptions"
                    multiple
                    v-model="rePMBrand"
                  ></select2> -->
                  <treeselect
                    v-model="rePMBrand"
                    :multiple="true"
                    :options="rePMBrandOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทการตั้งค่า :</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMPMBrand'"
                    :name="'rePMPMBrand'"
                    :select2-options="rePMPMBrandOptions"
                    multiple
                    v-model="rePMPMBrand"
                  ></select2> -->
                  <treeselect
                    v-model="reAlertConfigType"
                    :multiple="true"
                    :options="reAlertConfigTypeOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>



              </div>
              <div class="row mb-3">
                <div class="col-xl-6">
                  <button type="submit" class="btn btn-primary">ค้นหา</button>
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="formReset"
                  >
                    ล้างค่าทั้งหมด
                  </button>
                </div>
                <div class="col-xl-6 text-right">
                  <router-link
                    to="AlertPMConfig/Add"
                    tag="button"
                    title="เพิ่ม"
                    class="btn btn-outline-brand"
                    v-if="this.$root.canShow(['super_admin','MANAGE_MASTER','MANAGE_SETTING'])"
                  >
                    <i class="fa fa-plus-circle"></i> เพิ่ม 
                  </router-link>
                
                </div>
              </div>
            </form>
            <!-- end: Search Form -->

            <!--begin: Datatable -->
            <div class="row">
              <div class="col-lg-12 table-responsive">
                <table
                  class="table-sm table-striped- table-bordered table-hover table-checkable"
                  id="brandTable"
                >
                  <thead>
                    <tr>
                      <th class="all">รหัสตัวแทนจำหน่าย</th>
                      <th class="all">ชื่อตัวแทนจำหน่าย</th>
                      <th class="all">ชื่อตัวแทนจำหน่ายย่อย</th>
                      <th class="all">รหัสร้านค้า</th>
                      <th class="all">ชื่อร้านค้า</th>
                      <th class="all">ชื่อร้านค้า 2</th>
                      <th class="all">แบรนด์สินค้า</th>
                      <th class="all">ประเภทการตั้งค่า</th>  
                      <th class="all">การจัดการ</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            <!--end: Datatable -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/BudgetBrand/" + this.data.budgetId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/BudgetBrand/" + this.data.budgetId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let BudgetBrandActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูล">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="deleteItem" v-if="data.showDeleteButton" title="ลบข้อมูล" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({
        path: `/Master/AlertPMConfig/Edit/${this.data.id}`,
      });
    },
    deleteItem: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูล ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูล <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/MasterOverdueSetting/" + this.data.id + "/DeleteAlertPMConfig")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      pmrAgentCodes: [],
      pmrShopCodes: [],
      pmrInActiveStatus: null,
      pmrRouteName: null,
      pmrPmUserId: [],

      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [],
      pmrSubAgentShopCodes : [],
      pmrSubAgentShopCodesOptions : [],

      rePMBrand: [],
      rePMBrandOptions: [],
      rePMPMBrandOptions: [],
      reAlertConfigTypeOptions : [],
      reAlertConfigType : [],
 
       

      reAlertConfigTypeOptions : [ 
        {
          id: "ALL",
          label: "ทั้งหมด",
        },
        {
          id: "ประเภทตัวแทนจำหน่าย",
          label: "ประเภทตัวแทนจำหน่าย",
        },
        {
          id: "ประเภทร้านค้า",
          label: "ประเภทร้านค้า",
        } 
      ],

      pmrAgentCodesOptions: [], 
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         //pmrSubAgentCodes
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.pmrAgentCodes, 
              shopCodes  : self.pmrSubAgentCodes,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              shopCodes : self.pmrShopCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 

    };
  },
  methods: {
    formReset: function(e) {
      let self = this; 
  
      self.pmrAgentCodes = [];
      self.pmrShopCodes = []; 
      self.pmrSubAgentCodes  = []; 
      self.pmrSubAgentShopCodes = [];  
      self.reAlertConfigType  = []; 
      self.rePMBrand = []; 
 

       
      $("#pmrAgentCodes")
        .val("")
        .trigger("change");

      $("#pmrShopCodes")
        .val("")
        .trigger("change");
 
      $("#rePMBrand")
      .val("")
      .trigger("change");

      $("#reAlertConfigType")
      .val("")
      .trigger("change");  

      $("#pmrSubAgentCodes")
      .val("")
      .trigger("change");

      $("#pmrSubAgentShopCodes")
        .val("")
        .trigger("change");
 
      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#brandTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#brandTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    CheckRoute() {
      var url = this.$route.path;
      console.log(this.$route.params.id);
      if (url == "/Master/AlertPMConfig/Edit/" + this.$root.$route.params.id)
        return false;
      else if (url == "/Master/AlertPMConfig/Add") return false;
      else return true;
    },
    LoadpmrAgentCodesOptions: function(e) {
      var self = this;
      axios
        .post(
          self.$root.canShow(["AGENT_ADMIN_PM"])
            ? "/Api/Agents/AgentOptions"
            : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          {
            province_id: [],
            department: [],
            agentCodes: [],
            page: 1,
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.pmrAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/PM/ProductBrandOptions", {
          params: {
            page: 1,
           // productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMBrandOptions.push({
                id: element.data,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    AgentClearAfterselect: function(){  
      let self = this;

       
      self.pmrShopCodes= [];
      self.pmrSubAgentCodes = []; 
      self.pmrSubAgentShopCodes = []; 
 
      $("#pmrShopCodes").val("").trigger("change");
      $("#pmrSubAgentCodes").val("").trigger("change");
      $("#pmrSubAgentShopCodes").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    SubAgentClearAfterselect: function(){  
      let self = this;  
      self.pmrSubAgentShopCodes = []; 
   
      $("#pmrSubAgentShopCodes").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    ShopClearAfterselect: function(){  
      let self = this;  
       
      self.pmrSubAgentCodes = []; 
      self.pmrSubAgentShopCodes = []; 
  
      $("#pmrSubAgentCodes").val("").trigger("change");
      $("#pmrSubAgentShopCodes").val("").trigger("change");  
      $(`[class="vue-treeselect__input"]`).val("");

    },
    
    ClearAfterselect: function(){ 
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    //default Active Data
    self.LoadpmrAgentCodesOptions(); 
    self.LoadrePMBrandOptions();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#brandTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/MasterOverdueSetting/AlertPMConfigSearch",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                AgentCodes: self.pmrAgentCodes,
                ShopIds: self.pmrShopCodes,
                SubAgentCodes: self.pmrSubAgentCodes,
                SubAgentShopIds: self.pmrSubAgentShopCodes,
                BrandIds: self.rePMBrand,
                AlertTypes: self.reAlertConfigType,
              })
            );
          },
        },
  

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        
        order: [[0, "desc"]],
        columns: [
          { data: "agentCode" },
          { data: "agenT_NAME" },
          { data: "suB_AGENT_NAME" },
          { data: "shoP_CODE" },
          { data: "shoP_NAME" },
          { data: "shoP_NAME2" },
          { data: "brands" },
          { data: "alertType" },
          
          {
            data: "id",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
             'super_admin','MANAGE_MASTER','MANAGE_SETTING'
            ]);
            if (data.inActiveStatus == false)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == true)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              'super_admin','MANAGE_MASTER','MANAGE_SETTING'
            ]);
            data.showDeleteButton = self.$root.canShow([
              'super_admin','MANAGE_MASTER','MANAGE_SETTING'
            ]);
            new BudgetBrandActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/AlertPMConfig/PMList.vue